import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WhatWeDo from '../components/WhatWeDo';
import Expertise from '../components/Expertise';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import TrustedBy from '../components/TrustedBy';
import Process from '../components/Process';
import CaseStudies from '../components/CaseStudies';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <main className="bg-[#05080f] min-h-screen">
      <Navbar />
      <Hero />
      <WhatWeDo />
      <Expertise />
      <Services />
      <WhyChooseUs />
      <TrustedBy />
      <Process />
      <CaseStudies />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

export default HomePage;
